import React, { Suspense } from 'react';
import { appTutorialDataAtom } from './tutorial-app-atom';
import { useRecoilState } from 'recoil';
import { TUTORIAL_VIEWS } from './tutorial-data';
import LoadingG from '../loading/loadingG';
import DefaultModal from '../modal/modal';
const TutorialApp = ({ param1 }) => {
    const [state, _] = useRecoilState(appTutorialDataAtom);
    const CurrentView = (state === null || state === void 0 ? void 0 : state.currentView) ? TUTORIAL_VIEWS[state.currentView] : null;
    return (React.createElement(Suspense, { fallback: React.createElement(DefaultModal, { height: "50", hUnit: "%", width: "50", wUnit: "%", open: true },
            React.createElement(LoadingG, { text: 'Page is loading...' })) }, CurrentView ? React.createElement(CurrentView, null) : null));
};
export default TutorialApp;
